const API_URL = "";

let currentUser = JSON.parse(localStorage.getItem("currentUser")) || null;

export function login(username, token, rol) {
  currentUser = { username, token, rol: String(rol || "") };
  localStorage.setItem("currentUser", JSON.stringify(currentUser));
}

export function logout() {
  currentUser = null;
  localStorage.removeItem("currentUser");
}

export function getHeaders(extraHeaders = {}) {
  if (!currentUser) throw new Error("Usuario no autenticado. Haz login primero.");
  return {
    "Authorization": `Bearer ${currentUser.token}`,
    ...extraHeaders,
  };
}

export async function listarLicitaciones(pais = null) {
  const url = pais
    ? `${API_URL}/licitaciones/listar?pais=${encodeURIComponent(pais)}`
    : `${API_URL}/licitaciones/listar`;

  const res = await fetch(url, { headers: getHeaders() });

  const text = await res.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error(`Error HTTP ${res.status}: Respuesta no JSON (${text.slice(0, 100)})`);
  }

  if (!res.ok) {
    throw new Error(`Error al cargar licitaciones: ${data?.detail || data}`);
  }

  return data;
}

export async function obtenerLicitacion(numero) {
  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/detalle?numero=${encodeURIComponent(limpio)}`;

  const res = await fetch(url, { headers: getHeaders() });

  let data;
  try {
    data = await res.json();
  } catch {
    const text = await res.text();
    throw new Error(`Error obteniendo licitación '${limpio}': respuesta no JSON (${text.slice(0, 100)})`);
  }

  if (!res.ok) {
    throw new Error(`Error obteniendo licitación '${limpio}': ${data?.detail || res.status}`);
  }

  return data;
}

export async function guardarLicitacion(licitacion) {
  if (!currentUser) throw new Error("Usuario no autenticado");

  const url = `${API_URL}/licitaciones/crear`;

  const res = await fetch(url, {
    method: "POST",
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(licitacion),
  });

  const text = await res.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    console.error("Error parseando respuesta POST:", text.slice(0, 200));
    throw new Error(`Error HTTP ${res.status} guardando: ${text.slice(0, 100)}`);
  }

  if (!res.ok) {
    throw new Error(`Error guardando licitación: ${data?.detail || data}`);
  }

  return data;
}

export async function editarLicitacion(numero, datos) {
  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/editar?numero=${encodeURIComponent(limpio)}`;
  console.log(`PUT licitacion: ${url}`);

  const res = await fetch(url, {
    method: "PUT",
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(datos),
  });

  let data;
  try {
    data = await res.json();
  } catch {
    const text = await res.text();
    console.error("Error parseando respuesta PUT:", text.slice(0, 200));
    throw new Error(`Error HTTP ${res.status} editando '${limpio}': ${text.slice(0, 100)}`);
  }

  if (!res.ok) {
    throw new Error(`Error editando licitación '${limpio}': ${data?.detail || data}`);
  }

  return data;
}

export async function eliminarLicitacion(numero) {
  if (!currentUser) throw new Error("Usuario no autenticado");

  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/eliminar?numero=${encodeURIComponent(limpio)}`;
  console.log(`DELETE licitacion: ${url}`);

  const res = await fetch(url, {
    method: "DELETE",
    headers: getHeaders(),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(data?.detail || `Error eliminando licitación '${limpio}'`);
  }

  return data;
}

export async function aceptarLicitacion(numero) {
  if (!currentUser) throw new Error("Usuario no autenticado");

  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/aceptar?numero=${encodeURIComponent(limpio)}`;

  const res = await fetch(url, {
    method: "POST",
    headers: getHeaders(),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(data?.detail || `Error al aceptar licitación '${limpio}'`);
  }

  return data;
}

export async function rechazarLicitacion(numero) {
  if (!currentUser) throw new Error("Usuario no autenticado");

  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/rechazar?numero=${encodeURIComponent(limpio)}`;

  const res = await fetch(url, {
    method: "POST",
    headers: getHeaders(),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(data?.detail || `Error al rechazar licitación '${limpio}'`);
  }

  return data;
}

export async function aceptarLicitacionesMasivas(numeros) {
  if (!currentUser) throw new Error("Usuario no autenticado");

  const url = `${API_URL}/licitaciones/aceptar_masivas`;

  const res = await fetch(url, {
    method: "POST",
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(numeros),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(data?.detail || "Error al aceptar las licitaciones seleccionadas");
  }

  return data;
}

export async function rechazarLicitacionesMasivas(numeros) {
  if (!currentUser) throw new Error("Usuario no autenticado");

  const url = `${API_URL}/licitaciones/rechazar_masivas`;

  const res = await fetch(url, {
    method: "POST",
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(numeros),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(data?.detail || "Error al rechazar las licitaciones seleccionadas");
  }

  return data;
}

export async function listarDocumentos(numero) {
  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/documentos?numero=${encodeURIComponent(limpio)}`;
  console.log('URL:', url);

  const headers = getHeaders();

  const res = await fetch(url, { headers });
  console.log('Response status:', res.status, res.statusText);

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    console.error('Error response:', errorData);
    throw new Error(errorData?.detail || `Error al listar documentos (${res.status})`);
  }

  return await res.json();
}

export async function subirDocumento(numero, file) {
  const formData = new FormData();
  formData.append("archivo", file);

  const headers = getHeaders();
  delete headers["Content-Type"];

  const limpio = (numero || "").trim().toLowerCase();

  const url = `${API_URL}/licitaciones/documentos/subir?numero=${encodeURIComponent(limpio)}`;
  console.log("Subiendo documento a:", url);

  const res = await fetch(url, {
    method: "POST",
    headers,
    body: formData,
  });

  const text = await res.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    data = text;
  }

  if (!res.ok) {
    throw new Error(
      data?.detail || (typeof data === "string" ? data : JSON.stringify(data))
    );
  }

  return data;
}

export async function eliminarDocumento(numero, nombre) {
  const limpio = (numero || "").trim().toLowerCase();
  const basename = nombre.split("/").pop().split("\\").pop();

  const url = `${API_URL}/licitaciones/documentos/eliminar?numero=${encodeURIComponent(limpio)}&nombre=${encodeURIComponent(basename)}`;
  console.log("Eliminar documento URL:", url);

  const res = await fetch(url, {
    method: 'DELETE',
    headers: getHeaders()
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(errorData?.detail || `Error eliminando documento '${basename}'`);
  }

  return await res.json();
}

export async function generarResumenIA(numero, opciones = {}) {
  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/resumen_ia?numero=${encodeURIComponent(limpio)}`;

  const payload = typeof opciones === "string"
    ? { enlace: opciones, origen: "auto" }
    : {
      enlace: opciones?.enlace || null,
      origen: opciones?.origen || "auto",
      documento_nombre: opciones?.documentoNombre || null,
    };

  const res = await fetch(url, {
    method: 'POST',
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(errorData?.detail || `Error al generar el resumen para '${limpio}'`);
  }

  return await res.json();
}

export async function obtenerInfoIA(numero) {
  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/ia_info?numero=${encodeURIComponent(limpio)}`;

  const res = await fetch(url, { headers: getHeaders() });
  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(errorData?.detail || `Error al obtener información IA para '${limpio}'`);
  }

  return await res.json();
}

export async function preguntarChatIA(numero, pregunta, historial = [], enlace = null) {
  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/chat_ia?numero=${encodeURIComponent(limpio)}`;

  const res = await fetch(url, {
    method: "POST",
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ pregunta, historial, enlace }),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(errorData?.detail || "Error al consultar al asistente IA");
  }

  return await res.json();
}

export async function obtenerEstudio(numero, tipo) {
  const limpio = (numero || "").trim().toLowerCase();
  const tipoLimpio = (tipo || "").trim().toLowerCase();

  const url = `${API_URL}/licitaciones/estudios?numero=${encodeURIComponent(limpio)}&tipo=${encodeURIComponent(tipoLimpio)}`;
  console.log("Obteniendo estudio URL:", url);

  const res = await fetch(url, { headers: getHeaders() });
  if (!res.ok) return null;

  try {
    return await res.json();
  } catch {
    console.error("Error parseando JSON de estudio");
    return null;
  }
}

export async function guardarEstudio(numero, tipo, datos) {
  const limpio = (numero || "").trim().toLowerCase();
  const tipoLimpio = (tipo || "").trim().toLowerCase();

  const url = `${API_URL}/licitaciones/estudios?numero=${encodeURIComponent(limpio)}&tipo=${encodeURIComponent(tipoLimpio)}`;
  console.log("Guardando estudio URL:", url);

  const res = await fetch(url, {
    method: "POST",
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(datos),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(
      data?.detail || `Error guardando estudio '${tipoLimpio}': ${JSON.stringify(data)}`
    );
  }

  return data;
}

export async function eliminarEstudio(numero, tipo) {
  const limpio = (numero || "").trim().toLowerCase();
  const tipoLimpio = (tipo || "").trim().toLowerCase();

  const url = `${API_URL}/licitaciones/estudios?numero=${encodeURIComponent(limpio)}&tipo=${encodeURIComponent(tipoLimpio)}`;
  console.log("Eliminando estudio URL:", url);

  const res = await fetch(url, {
    method: "DELETE",
    headers: getHeaders(),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(
      errorData?.detail || `Error eliminando estudio '${tipoLimpio}'`
    );
  }

  return await res.json();
}

export async function exportarExcel(numero) {
  const limpio = (numero || "").trim().toLowerCase();

  const url = `${API_URL}/exportar_excel?numero=${encodeURIComponent(limpio)}`;
  console.log("Exportando Excel URL:", url);

  const resp = await fetch(url, { headers: getHeaders() });

  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    throw new Error(data.detail || "Error al generar Excel");
  }

  const blob = await resp.blob();
  const urlBlob = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = urlBlob;
  a.download = `estudio_${limpio}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export async function listarPaises() {
  const headers = currentUser ? getHeaders() : {};
  const url = `${API_URL}/licitaciones/paises`;

  console.log("Listando países URL:", url);

  const res = await fetch(url, { headers });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Error al listar países");
  }

  return await res.json();
}

export async function autenticarUsuario(username, password) {
  const url = `${API_URL}/usuarios/login`;
  console.log("Login URL:", url);

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username: (username || "").trim(), password: (password || "").trim() }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Error de autenticación");
  }

  const data = await res.json();
  // data: { access_token, token_type, rol }
  login((username || "").trim(), data.access_token, data.rol);
  return data.rol;
}

export async function crearUsuario(usuario) {
  const url = `${API_URL}/usuarios`;
  console.log("Creando usuario URL:", url);

  const payload = {
    username: (usuario.username || "").trim(),
    password: (usuario.password || "").trim(),
    rol: (usuario.rol || "user").trim(),
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      ...getHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const text = await response.text();

  if (!response.ok) {
    console.error("Error al crear usuario:", text);
    let errorData;
    try { errorData = JSON.parse(text); } catch { errorData = text; }
    throw new Error(errorData?.detail || errorData || "Error creando usuario");
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export async function listarUsuarios() {
  const url = `${API_URL}/usuarios`;
  console.log("Listando usuarios URL:", url);

  const res = await fetch(url, { headers: getHeaders() });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.detail || "Error al listar usuarios");
  }

  return await res.json();
}

export async function eliminarUsuario(username) {
  if (!username) throw new Error("Debe especificar un usuario");

  const encoded = encodeURIComponent((username || "").trim());
  const url = `${API_URL}/usuarios/${encoded}`;
  console.log("Eliminando usuario URL:", url);

  const res = await fetch(url, {
    method: "DELETE",
    headers: getHeaders(),
  });

  const text = await res.text();

  if (!res.ok) {
    let errorData;
    try { errorData = JSON.parse(text); } catch { errorData = text; }
    throw new Error(errorData?.detail || errorData || "Error al eliminar usuario");
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export async function actualizarUsuario({ username, password, rol }) {
  if (!username) throw new Error("Debe especificar un usuario");
  if (!rol) throw new Error("El campo 'rol' es obligatorio");

  const encoded = encodeURIComponent((username || "").trim());
  const url = `${API_URL}/usuarios/${encoded}`;
  console.log("Actualizando usuario URL:", url);

  const res = await fetch(url, {
    method: "PUT",
    headers: { ...getHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ password, rol }),
  });

  const text = await res.text();

  if (!res.ok) {
    let errorData;
    try { errorData = JSON.parse(text); } catch { errorData = text; }
    throw new Error(errorData?.detail || errorData || "Error al actualizar usuario");
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export async function importarLicitacionesCSV(file) {
  if (!currentUser) throw new Error("Usuario no autenticado");
  const rolStr = String(currentUser.rol || "");

  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(
    `${API_URL}/licitaciones/importar_csv?rol=${encodeURIComponent(rolStr)}`,
    {
      method: "POST",
      headers: getHeaders(),
      body: formData,
    }
  );

  const text = await res.text();
  let data = null;
  try {
    data = JSON.parse(text);
  } catch {
    data = text;
  }

  if (!res.ok) {
    throw new Error(
      `Error importando CSV de licitaciones: ${data?.detail || JSON.stringify(data)
      }`
    );
  }
  return data;
}

export async function eliminarLicitacionesCerradas() {
  const res = await fetch(`${API_URL}/licitaciones/cerradas`, {
    method: "DELETE",
    headers: getHeaders(),
  });

  const text = await res.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    data = text;
  }

  if (!res.ok) {
    throw new Error(
      data?.detail ||
      (typeof data === "string" ? data : JSON.stringify(data))
    );
  }

  return data;
}

export async function toggleFavorito(numero) {
  const limpio = (numero || "").trim().toLowerCase();
  const url = `${API_URL}/licitaciones/favorito?numero=${encodeURIComponent(limpio)}`;
  console.log(`POST toggle favorito: ${url}`);

  const res = await fetch(url, {
    method: "POST",
    headers: getHeaders(),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.detail || "Error al cambiar estado favorito");
  }

  return await res.json();
}

export async function getLogs() {
  const url = `${API_URL}/api/logs`;
  const res = await fetch(url, { headers: getHeaders() });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Error al obtener logs");
  }
  return await res.json();
}
